import React from 'react';
import { useAppContext } from '@prisjakt/ui-app-context';
import ShowMore from '../show-more';
import { isActiveMarket } from './utils';
import * as S from './styles';

type OwnProps = {
  className?: string;
  countryCode: string;
  currency?: string;
  id: string;
  marketplace?: boolean;
  minify?: boolean;
  storeName: string;
};

const LocationAndCurrencyInfo = ({
  className,
  countryCode,
  currency,
  id,
  marketplace,
  minify = false,
  storeName,
}: OwnProps) => {
  const { t } = useAppContext();

  const shouldMinify = minify && marketplace;

  const textIdentifier = `text-id-${id}`;

  const renderLocationAndCurrencyInfo = (locationAndCurrencyInfo: string) => (
    <S.LocationAndCurrencyInfo className={className}>
      <S.CountryFlag countryCode={countryCode} showTitleAsTooltip={false} />
      {shouldMinify ? (
        <ShowMore
          textIdentifier={textIdentifier}
          hideOnExpand
          maxHeight={32}
          size="small"
        >
          <S.Text id={textIdentifier}>{locationAndCurrencyInfo}</S.Text>
        </ShowMore>
      ) : (
        <S.Text>{locationAndCurrencyInfo}</S.Text>
      )}
    </S.LocationAndCurrencyInfo>
  );

  const countryName =
    isActiveMarket(countryCode) &&
    // @ts-ignore
    (t('common', `market.${countryCode}`) as string);

  if (marketplace && storeName && countryName)
    return renderLocationAndCurrencyInfo(
      t('store', 'store.is-marketplace', {
        storeName,
        country: countryName,
      })
    );

  const locationAndCurrencyInfo = [
    countryName &&
      t('store', 'store.located-in', {
        country: countryName,
      }),
    currency &&
      t('store', 'store.uses-currency', {
        currency,
      }),
  ]
    .filter(Boolean)
    .join(' ');

  return renderLocationAndCurrencyInfo(locationAndCurrencyInfo);
};

export default LocationAndCurrencyInfo;
